var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    { staticClass: "select-e-sign-signers" },
    [
      _c("b-col", { attrs: { cols: "12" } }, [
        _c("p", [
          _vm._v(
            "\n      " +
              _vm._s(_vm.$t("e-sign-package.messages.nowReviewSigners")) +
              "\n      "
          ),
          _vm.templateSelected
            ? _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.$t("e-sign-package.messages.ensureThatYouHaveAssigned")
                  )
                ),
              ])
            : _vm._e(),
          _vm._v(
            "\n      " +
              _vm._s(_vm.$t("e-sign-package.messages.chooseFromListBelow")) +
              ":\n    "
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "b-col",
        { staticClass: "b-2", attrs: { cols: "12" } },
        [
          _vm.signersValues.length
            ? _c("v-client-table", {
                staticClass: "vue-custom-table no-pagination",
                attrs: {
                  data: _vm.signersValues,
                  columns: _vm.table.columns,
                  options: _vm.table.options,
                  name: "selectFilesTable",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "name",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          _c(
                            "h5",
                            {
                              staticClass:
                                "mb-0 font-sm text-light-gray bold d-inline",
                            },
                            [
                              _vm._v(
                                "\n          " + _vm._s(row.name) + "\n        "
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                    {
                      key: "email",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          _c(
                            "h5",
                            {
                              staticClass:
                                "mb-0 font-sm text-primary bold d-inline",
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(row.email) +
                                  "\n        "
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                    _vm.templateSelected
                      ? {
                          key: "role",
                          fn: function (ref) {
                            var row = ref.row
                            return [
                              _c("select-section", {
                                attrs: {
                                  "class-name": "table-select",
                                  required: "",
                                  name: "signerType",
                                  placeholder: _vm.$tc(
                                    "e-sign-package.signerType",
                                    1
                                  ),
                                  options: _vm.signerRolesAvailable,
                                },
                                model: {
                                  value: _vm.signers[row.email].role,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.signers[row.email],
                                      "role",
                                      $$v
                                    )
                                  },
                                  expression: "signers[row.email].role",
                                },
                              }),
                            ]
                          },
                        }
                      : null,
                    {
                      key: "action",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          _c("inline-prompt", {
                            staticStyle: { "font-size": "0.8rem" },
                            attrs: {
                              "action-type": "delete",
                              placement: "left",
                            },
                            on: {
                              accept: function ($event) {
                                return _vm.handleDelete(row.email)
                              },
                            },
                          }),
                        ]
                      },
                    },
                  ],
                  null,
                  true
                ),
              })
            : _c(
                "div",
                { staticClass: "d-flex flex-column align-items-center" },
                [
                  _c(
                    "no-results",
                    {
                      attrs: {
                        "img-src": require("@Shared/@Assets/img/application-missing.png"),
                      },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.$t("e-sign-package.messages.emptySigners")
                          ) +
                          "\n      "
                      ),
                    ]
                  ),
                ],
                1
              ),
          _vm._v(" "),
          !_vm.allRolesDisabled
            ? _c("table", { staticClass: "VueTables__table table" }, [
                _c("tbody", [
                  _c("tr", [
                    _c(
                      "td",
                      { staticClass: "bt-0 py-0 w-30" },
                      [
                        _c("text-section", {
                          attrs: {
                            "class-name": "required font-sm",
                            name: "name",
                            placeholder: "John Doe",
                          },
                          model: {
                            value: _vm.newSigner.name,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.newSigner,
                                "name",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "newSigner.name",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      { staticClass: "bt-0 p-0 w-30" },
                      [
                        _c("text-section", {
                          attrs: {
                            "class-name": "required font-sm",
                            type: "email",
                            name: "email",
                            placeholder: "john@email.com",
                          },
                          on: { change: _vm.handleAddSigner },
                          model: {
                            value: _vm.newSigner.email,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.newSigner,
                                "email",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "newSigner.email",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.templateSelected
                      ? _c(
                          "td",
                          { staticClass: "bt-0 py-0 pl-3 w-30" },
                          [
                            _c("select-section", {
                              attrs: {
                                "class-name": "table-select",
                                required: "",
                                name: "signerType",
                                placeholder: _vm.$tc(
                                  "e-sign-package.signerType",
                                  1
                                ),
                                options: _vm.signerRolesAvailable,
                              },
                              on: { change: _vm.handleAddSigner },
                              model: {
                                value: _vm.newSigner.role,
                                callback: function ($$v) {
                                  _vm.$set(_vm.newSigner, "role", $$v)
                                },
                                expression: "newSigner.role",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        staticClass: "bt-0 py-0 text-right pr-0 align-bottom",
                        staticStyle: { width: "9%" },
                      },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-primary btn-sm new-signer",
                            attrs: {
                              type: "button",
                              disabled: !_vm.newSignerValid,
                            },
                            on: { click: _vm.handleAddSigner },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("global.words.add")) +
                                "\n            "
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.enoughSignerRoles
            ? _c(
                "b-row",
                { staticClass: "justify-content-end" },
                [
                  _c(
                    "b-col",
                    { staticClass: "text-right", attrs: { cols: "7" } },
                    [
                      _c("h6", { staticClass: "text-danger" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.$t(
                                "e-sign-package.messages.tooManySignersErr",
                                {
                                  signers:
                                    _vm.signersWithoutRole.length +
                                    " " +
                                    _vm.$tc(
                                      "e-sign-package.signer",
                                      _vm.signersWithoutRole.length
                                    ),
                                }
                              )
                            ) +
                            "\n        "
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }